app.controller('ScheduleController', ['$scope', '$http', '$timeout', '$translate', '$compile', '$filter', function ($scope, $http, $timeout, $translate, $compile, $filter) {

	$scope.text = 'me@example.com';
	$scope.emailFormat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	// Default variables
	
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1;
	var yyyy = today.getFullYear();
	var nextYear = today.getFullYear() + 1;
	$scope.visitArea = 0;
	$scope.visitInstructor = 0;
	$scope.nameInstructor;
	$scope.choosenInstructor = false;
	$scope.nameActivity;
	$scope.choosenActivity = false;
	$scope.showFilters = showFilters;
	$scope.showCapacity = showCapacity;
	$scope.allowBooking = allowBooking;
	$scope.startMonday = startMonday;
	$scope.filterActivity = filterActivity;
	$scope.showInstructor = showInstructor;
	$scope.paymentMethods = new Array("OnSide", "Membership", "Sodexo", "MultiSport", "Voucher", "EPay", "PaySafe", "Stripe");
	$scope.listView = true;
	$scope.currentGymId = gymid;
	$scope.modalLoading = false;
	$scope.emptySchedule = false;
	$scope.activityId = null;
	$scope.peopleWaiting = 0;
	$scope.logo = logo;
	$scope.showLogo = showLogo;
	$scope.login = login;
	$scope.loginRequired = loginRequired;
	$scope.paymentElavon= {};
	var $translateThis = $filter('translate');
	$scope.smodal = {paymentMethod: null, email: ''};

	$scope.requireLogin = false;

	if(loginRequired && !client){
		$scope.requireLogin = true;
	}

	if( client != null ){
		$scope.client = client;
	}

	if(gym){
		$scope.gym = gym;

		$scope.phoneFormat = gym[0].Culture.includes('GB') ? /^[0-9\s]{5,11}$/ : /^[0-9]{5,15}$/;

		$($scope.gym[0].BODYPart).prependTo('.body-scripts');
		$($scope.gym[0].HEADPart).appendTo(document.head);
	}

	$scope.gymAreaOnly = false;
	if ( gymArea ){
		$scope.gymAreaOnly = true;
	}

	$scope.lang = lang;

	if (showFilters == false) {
		var time = new Date().getTime();
		$(document.body).bind("mousemove keypress touchstart touch", function (e) {
			time = new Date().getTime();
		});

		var timeout = 900000;

		function refresh() {
			if (new Date().getTime() - time >= timeout) {
				window.location.reload(true);
			} else {
				setTimeout(refresh, timeout);
			}
		}

		setTimeout(refresh, timeout);
	}


	// Finding TimeZone Offset
	const timeZones = ["Europe/Andorra","Asia/Dubai","Asia/Kabul","Europe/Tirane","Asia/Yerevan","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia","Pacific/Pago_Pago","Europe/Vienna","Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla","Asia/Baku","America/Barbados","Asia/Dhaka","Europe/Brussels","Europe/Sofia","Atlantic/Bermuda","Asia/Brunei","America/La_Paz","America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco","America/Nassau","Asia/Thimphu","Europe/Minsk","America/Belize","America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Atikokan","America/Winnipeg","America/Rainy_River","America/Resolute","America/Rankin_Inlet","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Whitehorse","America/Dawson","America/Vancouver","Indian/Cocos","Europe/Zurich","Africa/Abidjan","Pacific/Rarotonga","America/Santiago","America/Punta_Arenas","Pacific/Easter","Asia/Shanghai","Asia/Urumqi","America/Bogota","America/Costa_Rica","America/Havana","Atlantic/Cape_Verde","America/Curacao","Indian/Christmas","Asia/Nicosia","Asia/Famagusta","Europe/Prague","Europe/Berlin","Europe/Copenhagen","America/Santo_Domingo","Africa/Algiers","America/Guayaquil","Pacific/Galapagos","Europe/Tallinn","Africa/Cairo","Africa/El_Aaiun","Europe/Madrid","Africa/Ceuta","Atlantic/Canary","Europe/Helsinki","Pacific/Fiji","Atlantic/Stanley","Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae","Atlantic/Faroe","Europe/Paris","Europe/London","Asia/Tbilisi","America/Cayenne","Africa/Accra","Europe/Gibraltar","America/Nuuk","America/Danmarkshavn","America/Scoresbysund","America/Thule","Europe/Athens","Atlantic/South_Georgia","America/Guatemala","Pacific/Guam","Africa/Bissau","America/Guyana","Asia/Hong_Kong","America/Tegucigalpa","America/Port-au-Prince","Europe/Budapest","Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura","Europe/Dublin","Asia/Jerusalem","Asia/Kolkata","Indian/Chagos","Asia/Baghdad","Asia/Tehran","Atlantic/Reykjavik","Europe/Rome","America/Jamaica","Asia/Amman","Asia/Tokyo","Africa/Nairobi","Asia/Bishkek","Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati","Asia/Pyongyang","Asia/Seoul","Asia/Almaty","Asia/Qyzylorda","Asia/Qostanay","Asia/Aqtobe","Asia/Aqtau","Asia/Atyrau","Asia/Oral","Asia/Beirut","Asia/Colombo","Africa/Monrovia","Europe/Vilnius","Europe/Luxembourg","Europe/Riga","Africa/Tripoli","Africa/Casablanca","Europe/Monaco","Europe/Chisinau","Pacific/Majuro","Pacific/Kwajalein","Asia/Yangon","Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan","Asia/Macau","America/Martinique","Europe/Malta","Indian/Mauritius","Indian/Maldives","America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Bahia_Banderas","Asia/Kuala_Lumpur","Asia/Kuching","Africa/Maputo","Africa/Windhoek","Pacific/Noumea","Pacific/Norfolk","Africa/Lagos","America/Managua","Europe/Amsterdam","Europe/Oslo","Asia/Kathmandu","Pacific/Nauru","Pacific/Niue","Pacific/Auckland","Pacific/Chatham","America/Panama","America/Lima","Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier","Pacific/Port_Moresby","Pacific/Bougainville","Asia/Manila","Asia/Karachi","Europe/Warsaw","America/Miquelon","Pacific/Pitcairn","America/Puerto_Rico","Asia/Gaza","Asia/Hebron","Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores","Pacific/Palau","America/Asuncion","Asia/Qatar","Indian/Reunion","Europe/Bucharest","Europe/Belgrade","Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Kirov","Europe/Volgograd","Europe/Astrakhan","Europe/Saratov","Europe/Ulyanovsk","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Barnaul","Asia/Tomsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Ust-Nera","Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr","Asia/Riyadh","Pacific/Guadalcanal","Indian/Mahe","Africa/Khartoum","Europe/Stockholm","Asia/Singapore","America/Paramaribo","Africa/Juba","Africa/Sao_Tome","America/El_Salvador","Asia/Damascus","America/Grand_Turk","Africa/Ndjamena","Indian/Kerguelen","Asia/Bangkok","Asia/Dushanbe","Pacific/Fakaofo","Asia/Dili","Asia/Ashgabat","Africa/Tunis","Pacific/Tongatapu","Europe/Istanbul","America/Port_of_Spain","Pacific/Funafuti","Asia/Taipei","Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye","Pacific/Wake","America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Anchorage","America/Juneau","America/Sitka","America/Metlakatla","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu","America/Montevideo","Asia/Samarkand","Asia/Tashkent","America/Caracas","Asia/Ho_Chi_Minh","Pacific/Efate","Pacific/Wallis","Pacific/Apia","Africa/Johannesburg","America/Antigua","America/Anguilla","Africa/Luanda","Antarctica/McMurdo","America/Aruba","Europe/Mariehamn","Europe/Sarajevo","Africa/Ouagadougou","Asia/Bahrain","Africa/Bujumbura","Africa/Porto-Novo","America/St_Barthelemy","America/Kralendijk","Africa/Gaborone","Africa/Kinshasa","Africa/Lubumbashi","Africa/Bangui","Africa/Brazzaville","Africa/Douala","Europe/Busingen","Africa/Djibouti","America/Dominica","Africa/Asmara","Africa/Addis_Ababa","Africa/Libreville","America/Grenada","Europe/Guernsey","Africa/Banjul","Africa/Conakry","America/Guadeloupe","Africa/Malabo","Europe/Zagreb","Europe/Isle_of_Man","Europe/Jersey","Asia/Phnom_Penh","Indian/Comoro","America/St_Kitts","Asia/Kuwait","America/Cayman","Asia/Vientiane","America/St_Lucia","Europe/Vaduz","Africa/Maseru","Europe/Podgorica","America/Marigot","Indian/Antananarivo","Europe/Skopje","Africa/Bamako","Pacific/Saipan","Africa/Nouakchott","America/Montserrat","Africa/Blantyre","Africa/Niamey","Asia/Muscat","Africa/Kigali","Atlantic/St_Helena","Europe/Ljubljana","Arctic/Longyearbyen","Europe/Bratislava","Africa/Freetown","Europe/San_Marino","Africa/Dakar","Africa/Mogadishu","America/Lower_Princes","Africa/Mbabane","Africa/Lome","Africa/Dar_es_Salaam","Africa/Kampala","Pacific/Midway","Europe/Vatican","America/St_Vincent","America/Tortola","America/St_Thomas","Asia/Aden","Indian/Mayotte","Africa/Lusaka","Africa/Harare" ]

	let timezoneP = timeZone.split(') ');
	let timezonePi = timezoneP[1].split(',');
	let timeZoneC = timezonePi[0];
	let timeZoneF = timeZones.find(el => el.includes(timeZoneC)); 

	let timeZoneOffsetSplit = timezoneP[0].split('UTC');
	$scope.timeZoneOffset = timeZoneOffsetSplit[1];

	moment.tz.setDefault(timeZoneF);

	if (dd < 10) {
		dd = '0' + dd
	}

	if (mm < 10) {
		mm = '0' + mm
	}

	today = mm + '/' + dd + '/' + yyyy;
	todayInOneYear = mm + '/' + dd + '/' + nextYear;

	var schedule_from = $("#schedule_from");
	var schedule_to = $("#schedule_to");
	$scope.scheduleStartDate = today;
	if (days != null) {
		let today = new Date();
		let dd = today.getDate();
		dd += days;
		if (dd < 10) {
			dd = '0' + dd
		}
		$scope.scheduleEndDate = mm + '/' + dd + '/' + yyyy;
	}else{
		$scope.scheduleEndDate = todayInOneYear;
	}

	if (settings) {
		$scope.classSettings = settings;
		
		if($scope.classSettings.ShowScheduleDaysAhead > 0 ){
			let date = new Date($scope.scheduleStartDate);
			date.setDate(date.getDate() + $scope.classSettings.ShowScheduleDaysAhead);
			date = new Date(date);

			let dd = date.getDate();
			let mm = date.getMonth() + 1;
			let yyyy = date.getFullYear();

			$scope.scheduleEndDate = mm + '/' + dd + '/' + yyyy;
		}
	}

	function findElement(arr, propName, propValue) {
		for (var i = 0; i < arr.length; i++)
			if (arr[i][propName] == propValue)
				return arr[i];
		// will return undefined if not found; you could return a default instead
	}

	$scope.getEventsType = function(dgymID){
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetPublicEvents?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_activities = data;
			$scope.getAreas();
		}).error(function () {

		});
	}
	// $scope.getEventsType();

	// Get Areas
	$scope.getAreas = function (dgymID) {
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymId: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetAreas?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_areas = data;

			setTimeout(function() {
				if ( dgymID ) {
					$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, dgymID);
				}else{
					$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate);
				}
			}, 500);
		}).error(function () {

		});
	}

	function getMonday(d) {
		d = new Date(d);
		var day = d.getDay();

		var diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday

		$scope.scheduleStartDate = new Date(d.setDate(diff));
	}

	// Get Schedule
	$scope.getSchedule = function (from, to, dgymID, dontUpdateActInstr) {
		var updateActInstr = true;

		if ( dontUpdateActInstr != undefined ){
			updateActInstr = false;
		}

		if ($scope.startMonday == true) {
			getMonday($scope.scheduleStartDate);
		}

		if ( dgymID ) {
			gymid = dgymID;
		}

		if ( gymArea ){
			$scope.visitArea = gymArea;
		}

		if ( currentActivity ){
			$scope.activityId = currentActivity;
		}


		var dataObject = {
			GymID: gymid,
			Namespace: namespace,
			DateStart: $scope.scheduleStartDate,
			DateEnd: $scope.scheduleEndDate,
			AreaID: $scope.visitArea,
			InstructorID: $scope.visitInstructor,
			Private: true,
			PublicEventID: $scope.activityId,
			CategoryID: categoryID,
			SubCategoryID: subCategoryID
		}

		$http({
			method: 'POST',
			url: '/api/public/GetSchedule',
			data: dataObject
		}).success(function (data) {
			var today = new Date();
			var currentActivities = [];
			var currentInstructors = [];
			$scope.originalData = data;
			$scope.testData = [];
			$scope.calendarSchedule = [];
			$scope.Schedule = {};

			if(data.length > 0){
				$scope.emptySchedule = false;
				angular.copy(data, $scope.testData);
				for (var i = 0; i < $scope.testData.length; ++i) {
					var DateNewDate = moment($scope.testData[i]['Date']);
					var DateNewDateEnd = moment($scope.testData[i]['DateEnd']);

					var isDstChangeDay = moment(DateNewDate).isDST();
					if ( isDstChangeDay ){
						DateNewDate = moment(DateNewDate).add(1, 'hours');
						DateNewDateEnd = moment(DateNewDateEnd).add(1, 'hours');
					}

					var convertedDate = DateNewDate.toString();
					var convertedDateEnd = DateNewDateEnd.toString();
					var x = findElement($scope.schedule_areas, "AreaID", $scope.testData[i]['AreaID']);

					$scope.testData[i]['NewDate'] = moment(convertedDate).toDate();
					$scope.testData[i]['NewDateEnd'] = moment(convertedDateEnd).toDate();
					
					if (x != undefined && x['Name'] != undefined)
						$scope.testData[i]['AreaName'] = x['Name'];

					$scope.testData[i]['ShowParticipantsCount'] = x != undefined ? x['ShowParticipantsCount'] : false;

					var testDateBeforeBooking = new Date($scope.testData[i]['Date']);
					testDateBeforeBooking.setHours(moment($scope.testData[i]['Date']).hours() - $scope.classSettings.HoursBeforeBooking);
					$scope.testData[i]['HoursBeforeBooking'] = testDateBeforeBooking;

					if($scope.testData[i]['Color'].length > 7){
						let firstTwo = $scope.testData[i]['Color'].slice(1, 3);
						let mainColor = $scope.testData[i]['Color'].slice(3, 9);
						let newColor = '#'+mainColor+firstTwo;
						$scope.testData[i]['Color'] = newColor;
					}

					var testDatedaysAheadBooking = new Date(convertedDate);
					testDatedaysAheadBooking.setDate(testDatedaysAheadBooking.getDate() - $scope.classSettings.DaysAheadBooking);

					if (today >= testDatedaysAheadBooking || $scope.classSettings.DaysAheadBooking == 0) {
						$scope.testData[i]['AheadBooking'] = true;
					} else {
						$scope.testData[i]['AheadBooking'] = false;
					}

					if ( $scope.testData[i]['PeopleAttending'] >= $scope.testData[i]['MaxClients']) {
						$scope.testData[i]['FullCapacity'] = true;
					}else{
						$scope.testData[i]['FullCapacity'] = false;
					}

					$scope.testData[i]['SlotsLeft'] = $scope.testData[i]['PeopleAttending'] >= $scope.testData[i]['MaxClients'] ? '0' : $scope.testData[i]['MaxClients'] - $scope.testData[i]['PeopleAttending'];

					var item = {
						title: $scope.testData[i]['VisitName'],
						start: $scope.testData[i]['Date'],
						end: $scope.testData[i]['DateEnd'],
						backgroundColor: $scope.testData[i]['Color'],
						extendedProps: {
							zone: $scope.testData[i]['AreaName'],
							ID: $scope.testData[i]['ID'],
							AheadBooking: $scope.testData[i]['AheadBooking'],
							BookOnline: $scope.testData[i]['BookOnline'],
							HoursBeforeBooking: $scope.testData[i]['HoursBeforeBooking'],
							FullCapacity: $scope.testData[i]['FullCapacity'],
							WaitingList: $scope.testData[i]['WaitingList']
						}
					}

					$scope.calendarSchedule.push(item);

					if ( updateActInstr == true ) {
						if ( !currentActivities.includes($scope.testData[i]['PublicEventID']) ) {
							currentActivities.push($scope.testData[i]['PublicEventID']);
						}
					}

					if ( $scope.testData[i]['InstructorIDs'] != null ) {
						var manageInstrucors = $scope.testData[i]['InstructorIDs'];

						if ( manageInstrucors.indexOf(',') > -1 ) {
							var res = manageInstrucors.split(',');

							for (var n = 0; n < res.length; n++) {
								if ( !currentInstructors.includes(res[n]) ) {
									currentInstructors.push(res[n]);
								}

								var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == res[n] });
								if ( result.length > 0 ) {
									var instructor = result[0].Name;
									if ( n > 0 ) {
										instructor = ', ' + instructor;
									}
									$scope.testData[i]['Instructors']  += instructor;
								}
							}
						}else{
							if ( !currentInstructors.includes(manageInstrucors) && manageInstrucors != '00000000-0000-0000-0000-000000000000' && manageInstrucors != '' ) {
								currentInstructors.push(manageInstrucors);
							}

							var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == manageInstrucors });
							if ( result.length > 0 ) {
								$scope.testData[i]['Instructors'] = result[0].Name;
							}
						}
					}
				}

				if ( updateActInstr == true ){
					getCurrentActivities(currentActivities);
					getCurrentInstructors(currentInstructors);
				}

				$scope.originalData = $scope.testData;
				$scope.testData = $scope.convertTo($scope.testData, 'Date', true);

				Object.keys($scope.testData).sort().forEach(function (key) {
					$scope.Schedule[key] = $scope.testData[key];
				});

				if( $('.switch-field a.calendar').is('.active') ){
					fullCalendar($scope.calendarSchedule);
				}
			}else{
				$scope.emptySchedule = true;
			}
				
		}).error(function () {

		});
	}

	function getCurrentActivities(array){
		$scope.current_activities = [];

		for (var i = 0; i < array.length; i++) {
			var activity = array[i];
			var result = $.grep($scope.schedule_activities, function (e) { return e.Id == activity });

			if ( result.length > 0 ) {
				$scope.current_activities.push(result[0]);
			}
		}
	}

	function getCurrentInstructors(array){
		$scope.current_instructors = [];

		for (var i = 0; i < array.length; i++) {
			var instructor = array[i];
			var result = $.grep($scope.schedule_instructors, function (e) { return e.Id == instructor });

			if ( result.length > 0 ) {
				$scope.current_instructors.push(result[0]);
			}
		}
	}

	function fullCalendar(calendarSchedule){
		if ( $('#calendar').children().length > 0 ) {
		    $('#calendar').fullCalendar('destroy');
		}
		
		// $('#calendar').fullCalendar({
		// 	events: calendarSchedule,
		// 	listDayAltFormat: false,
        //     listDayFormat: 'dddd DD.MM.YYYY ',
        //     nowIndicator: true,
        //     header: {
        //         left: 'title',
        //         center: '',
        //         right: 'prev,next'
        //     },
        //     lang: lang,
        //     locale: lang,
        //     height: 'auto',
        //     slotDuration: '00:30:00',
        //     timeFormat: 'HH:mm',
        //     defaultView: 'agendaWeek',
        //     allDaySlot: false,
        //     editable: false,
        //     droppable: false,
        //     minTime: '07:00:00',
        //     maxTime: '23:00:00',
        //     eventColor: '#3799b1',
        //     timezone: 'Europe/Sofia',
		// 	eventRender: function(event, element) {
		// 		if ( event.fullCapacity == true ) {
        //         	element.css({
        //         		"opacity": 0.5,
        //         		"pointer-events": "none"
        //         	})
		// 		}

        //         element.find('.fc-title').html('<span style="font-size: 1.1em; font-weight: 600;">'+event.title+'</span><span class="pull-right">'+event.zone+'</span>').css('white-space','nowrap');
		// 	},
		// 	eventClick: function(event, jsEvent){
		// 		var convertedDate = event.start.toString();
		// 		var convertedDateEnd = event.end.toString();
		// 		var eventStart = new Date(convertedDate);
		// 		var eventEnd = new Date(convertedDateEnd);
		// 		// $scope.joinModal(event.itemId);

		// 		$scope.eventLink(event);
		// 	},
		// 	eventAfterAllRender: function(view) {
		// 		setTimeout(function() {
		// 			$('body').addClass('loaded-body');
		// 		}, 1000);
		// 	}
		// });
		
		var calendarEl = document.getElementById('calendar');
        var calendar = new FullCalendar.Calendar(calendarEl, {
			timeZone: timeZoneF,
			listDaySideFormat: false,
            listDayFormat: 'dddd DD.MM.YYYY ',
            nowIndicator: true,
            headerToolbar: {
                start: 'title',
                center: '',
                end: 'prev,next'
            },
            locale: lang,
            height: 'auto',
            slotDuration: '00:30:00',
            eventTimeFormat: {
				hour: '2-digit',
    			minute: '2-digit',
				meridiem: false
			},
            initialView: 'timeGridWeek',
            allDaySlot: false,
            editable: false,
            droppable: false,
            slotMinTime: '07:00:00',
            slotMaxTime: '23:00:00',
            eventColor: '#3799b1',
			events: calendarSchedule,
			eventClick: function(eventClickInfo ){
				let event = {
					FullCapacity: eventClickInfo.event.extendedProps.FullCapacity,
					WaitingList: eventClickInfo.event.extendedProps.WaitingList,
					BookOnline: eventClickInfo.event.extendedProps.BookOnline,
					AheadBooking: eventClickInfo.event.extendedProps.AheadBooking,
					ID: eventClickInfo.event.extendedProps.ID,
				}

				$scope.eventLink(event);
			},
			eventDidMount: function(view) {
				setTimeout(function() {
					$('body').addClass('loaded-body');
				}, 1000);
			}
        });
        calendar.render();
		$('.lang-nav ul li a').on('click', function(e){
			let lang = $(this).data('lang');
			lang = lang == 'esc' ? 'ca' : lang;
			calendar.setOption('locale', lang);
		})

	}

	// Get Gyms
	$scope.getGyms = function () {
		$scope.membershipGyms = [];
		var dataObject = {
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/Membership/GetGyms',
			data: dataObject
		}).success(function (data) {
			if ( data.length > 0 ) {
				for (var i = 0; i < data.length; i++) {
					if ( data[i].IsOnline == true ) {
						$scope.membershipGyms.push(data[i]);
					}
				}

				$scope.gymid = $scope.membershipGyms[0].GymID;

				if( $scope.membershipGyms.length == 1 ){
					$timeout(function() {
						$scope.scheduleDivision = $scope.membershipGyms[0].GymID;
						$scope.updategymId($scope.membershipGyms[0].GymID);
						$('#scheduleDivisionSelect').val($scope.membershipGyms[0].GymID).trigger('change');
					});
				}else{
					$scope.updategymId(gymid);
				}
			}else{
				$scope.updategymId(gymid);
				$scope.gymAreaOnly = true;
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.getGyms();

	$('.switch-field a').on('click', function(e){
		e.preventDefault();
		var item = $(this);

		if ( !item.is('.active') ){
			item.addClass('active').siblings('.active').removeClass('active');
		}

		if ( item.is('.list') ){
			$('.schedule-list').show();
			$('#calendar').hide();
		}else{
			$('.schedule-list').hide();
			$('#calendar').show();
			fullCalendar($scope.calendarSchedule);
		}
	})

	$scope.convertTo = function (arr, key, dayWise) {
		var groups = {};

		for (var i = 0; l = arr.length, i < l; i++) {
			arr[i]['DateLocal'] = new Date(arr[i][key]).toISOString().slice(0, 10);

			groups[arr[i]['DateLocal']] = groups[arr[i]['DateLocal']] || [];
			groups[arr[i]['DateLocal']].push(arr[i]);
		}
		return groups;
	};

	$scope.updateAreaId = function (id, gymID) {
		$('body').removeClass('loaded-body');
		$('.filter-col-activities input:checked').prop('checked', false);
		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.activityId = null;
		$scope.choosenActivity = false;
		$scope.scheduleActivity = 'null';
		$scope.visitInstructor = 0;
		$scope.choosenInstructor = false;
		$scope.scheduleInstructor = '0';
		$scope.visitArea = id;
		if ( gymID ) {
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymID);
		}else{
			$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate);
		}
	}

	$scope.getSettings = function (id) {
		var dataObject = {
		    Namespace: namespace,
		    GymID: gymid
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/GetSettings',
			data: dataObject
		}).success(function (data) {
			$scope.classSettings = data;
			window.membershipCurrencyCode = data.CurrencyCode;

			if($scope.classSettings.ShowScheduleDaysAhead > 0 ){
				let date = new Date($scope.scheduleStartDate);
				date.setDate(date.getDate() + $scope.classSettings.ShowScheduleDaysAhead);
				date = new Date(date);

				let dd = date.getDate();
				let mm = date.getMonth() + 1;
				let yyyy = date.getFullYear();

				$scope.scheduleEndDate = mm + '/' + dd + '/' + yyyy;
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.updategymId = function (gymID) {
		$('body').removeClass('loaded-body');
		$scope.visitArea = 0;
		$scope.scheduleActivity = null;
		$scope.choosenActivity = false;
		$scope.activityId = null;
		$('.filter-col-instructors input:checked').prop('checked', false);
		$scope.choosenInstructor = false;
		$scope.visitInstructor = 0;
		$scope.scheduleActivity = 'null';
		$scope.scheduleInstructor = '0';
		$scope.scheduleArea = '0';
		// $scope.getAreas(gymID);
		$scope.getEventsType(gymID);
		$scope.getSettings(gymID);
		$scope.getInstructors(gymID);
		$('.schedule-wrapper .filter-section').addClass('choosedGym');
	}

	$scope.updateActivity = function (activityId) {
		$('body').removeClass('loaded-body');
		$scope.activityId = activityId;
		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');

		if (activityId != null) {
			var x = findElement($scope.schedule_activities, "Id", activityId);

			$scope.choosenActivity = true;
			$scope.nameActivity = x['Name'];
		} else {
			$scope.choosenActivity = false;
		}
	}


	// Get Instructors

	$scope.getInstructors = function (dgymID) {
		if ( dgymID ) {
			gymid = dgymID;
		}

		var dataObject = {
			Namespace: namespace,
			GymID: gymid
		}
		$http({
			method: 'GET',
			url: '/api/public/GetInstructors?nameSpace=' + namespace + '&gymId=' + gymid,
			data: dataObject
		}).success(function (data) {
			$scope.schedule_instructors = data;
		}).error(function () {

		});
	}

	// $scope.getInstructors();

	$scope.updateInstructorId = function (id) {
		$scope.visitInstructor = id;

		$scope.getSchedule($scope.scheduleStartDate, $scope.scheduleEndDate, gymid, 'dontUpdateActInstr');

		if (id != '0') {
			var x = findElement($scope.schedule_instructors, "Id", id);

			$scope.choosenInstructor = true;
			$scope.nameInstructor = x['Name'];
		} else {
			$scope.choosenInstructor = false;
		}
	}

	$scope.updateVisitProductPerson = function(item){
		if (item.productName && item.productName != 'Own equipment') {
			var result = $.grep($scope.visitProducts, function (e) { return e.ProductName == item.productName });
			result[0].ItemsLeft = ++result[0].ItemsLeft;
		}

		if ( item.productId != '-1' ) {
			var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == item.productId });
			item.productName = result[0].ProductName;
			item.productItemsLeft = result[0].ItemsLeft;
			result[0].ItemsLeft = --result[0].ItemsLeft;
		}else{
			item.productName = 'Own equipment'
		}

		return item;

	}
	
	$scope.updateVisitProduct = function(id){
		if ( id != '-1') {
			var result = $.grep($scope.visitProducts, function (e) { return e.ProductID == id });
			$scope.smodal.productId = id;
			$scope.smodal.productName = result[0].ProductName;
			result[0].ItemsLeft = --result[0].ItemsLeft;
		}else{
			$scope.smodal.productId = '-1';
			$scope.smodal.productName = 'Own equipment'
		}
	}

	function getEventPrice() {
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			id: $scope.PublicEventID,
		}
	    
	    $http({
	        method: 'GET',
	        url: '/private/GetPublicEventPrice?Namespace=' + namespace + '&GymID=' + gymid + '&id=' + $scope.PublicEventID,
	        data: dataObject
	    }).success(function (data) {
	        // console.log(data);
	        $scope.modalPrice = data;

			if( $('#selectPaymentMethod option.ng-scope').length == 1){
				$scope.smodal.paymentMethod = $('#selectPaymentMethod option.ng-scope').val();
				$scope.paymentChange();
			}
			
	        calculateEventPrice();
	    }).error(function () {
	    });
	}

	$scope.paymentChange = function(){
		if ($scope.smodal.paymentMethod == '7' && $scope.modalPrice > 0) {
			generatePaymentIntent();
		}else{
			$('.shcedule-popup .form-actions .button.stripe-button').removeClass('show');
		}
	}

	// Generate PaymentInted for Stripe
	function generatePaymentIntent() {
		$scope.PaymentIntentID = 0;
		let dataObject = prepareDataToSned();

		if ($scope.formLoaded == true) {
			$scope.formLoaded = false;
			$scope.loading = true;
			$http({
				method: 'POST',
				url: '/private/GeneratePaymentIntent',
				data: dataObject
			}).success(function (data) {

				if(data == 'Waiver Required!'){
					var translated = $translateThis('Waiver Required!Portal');
					var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/Schedulev2/EmbedGroupSchedulev2';
					Swal.fire({
						type: 'warning',
						title: translated,
						showCancelButton: true,
					}).then(function(result) {
						if (result.value) {
							window.location.href = waiverHref;
						}else{
							$timeout(function() {
								$scope.formLoaded = true;
								$scope.loading = false;
							}, 1);
						}
					});
				}else if(data == 'Customer banned from booking!'){
					let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
					Swal.fire({
						type: 'warning',
						title: translated
					});
					$scope.formLoaded = true;
					$scope.loading = false;
				}else if( data == 2 ){
					let translated = $translateThis(joinEventResponses[data]);
					Swal.fire({
						type: 'warning',
						title: translated
					});
					$scope.formLoaded = true;
					$scope.loading = false;
				}else{
					stripeInitialize(data);

					$scope.BookingOrderID = data.BookingOrderID;
					$scope.PaymentIntentID = data.ID;
					$scope.formLoaded = true;
				}
			}).error(function (error) {
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated
				});
				$scope.formLoaded = true;
				$scope.loading = false;
			});
		}
	}

	function stripeInitialize(data){
		$scope.stripe = Stripe($scope.classSettings.StripePublishKey, {
			betas: ['mb_way_pm_beta_1'],
		});
		
		const options = {
			clientSecret: data.ClientSecret,
			appearance: {/*...*/},
		};
		let clientName;
		if($scope.client){
			clientName = $scope.client.FirstName + ' ' + $scope.client.LastName;
		}else{
			clientName = $scope.scheduleFirstName + ' ' + $scope.scheduleLastName;
		}
		

		$scope.stripeElements = $scope.stripe.elements(options);
		$scope.stripeError = document.getElementById('error-message');
		const paymentElementOptions = { 
			layout: 'accordion',
			fields: {
				billingDetails: {
					address: {
						postalCode: $scope.classSettings.HidePostalCode ? 'never' : 'auto'
					}
				}
			},
			defaultValues: {
				billingDetails: {
					name: clientName,
					email: 'never',
                    phone: 'never'
				}
			}
		};
		const paymentElement = $scope.stripeElements.create('payment', paymentElementOptions);
		paymentElement.mount('#payment-element');
		$scope.loading = false;
	}

	function stripeConfirmPayment(){
		if (!$scope.stripe || !$scope.stripeElements) return;
		$scope.loading = true;

		$scope.stripe.confirmPayment({
			elements: $scope.stripeElements,
			redirect: 'if_required',
		}).then(function(result) {
			var error = result.error;
			var paymentIntent = result.paymentIntent;

			console.log(result);

			if (error) {
				$timeout(function() {
					$scope.loading = false;
					if ($scope.stripeError) $scope.stripeError.textContent = error.message;
				});
			} else {
				switch (paymentIntent.status) {
				case 'succeeded':
					// $scope.placeOrder(true);
					$scope.joinEvent();
					break;
				case 'requires_payment_method':
					$timeout(function() {
						$scope.loading = false;
						var msg = (paymentIntent.last_payment_error && paymentIntent.last_payment_error.message)
							? paymentIntent.last_payment_error.message
							: 'Payment failed. Please try another payment method.';
						var translatedMsg = $translateThis(msg);
						if ($scope.stripeError) $scope.stripeError.textContent = translatedMsg;
						Swal.fire({ type: 'warning', title: translatedMsg });
					});
					break;
				default:
					$timeout(function() {
						$scope.loading = false;
					});
					break;
				}
			}
		});
	}

	function prepareDataToSned(){
		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			Id: $scope.modalVisit.ID,
			Email: $scope.client ? $scope.client.Email : $scope.smodal.email,
			Date: moment($scope.modalVisit.NewDate).toISOString(),
			VisitName: $scope.modalVisit.VisitName,
			PaymentMethod: $scope.smodal.paymentMethod,
			Language: lang,
			ProductID: $scope.smodal.productId,
			ProductName: $scope.smodal.productName,
			AdditionalGuests: $scope.people,
			PaymentIntentID: $scope.PaymentIntentID,
			receiveEmails: $scope.smodal.MarketingEmailsClassBooking
		}

		if($scope.clientGroupMemberSel){
			let clientGroupMember = JSON.parse($scope.clientGroupMemberSel);
			dataObject.clientID = clientGroupMember.ClientID
		}

		if ( $scope.classSettings.ClassBookingRequireProfile != true ) {
			let tel;
			if($scope.inputPhone){
				tel = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
				tel = tel.replace(/ /g,'');
			}

			dataObject.FirstName = $scope.client ? $scope.client.FirstName : $scope.scheduleFirstName;
			dataObject.LastName = $scope.client ? $scope.client.LastName : $scope.scheduleLastName;
			dataObject.Telephone = $scope.client ? $scope.client.Telephone : tel;
		}

		if ( $scope.smodal.paymentMethod == '7' || $scope.smodal.paymentMethod == '8' || $scope.smodal.paymentMethod == '9' || $scope.smodal.paymentMethod == '10' || $scope.smodal.paymentMethod == '11' || $scope.smodal.paymentMethod == '12' || $scope.smodal.paymentMethod == '13') {
			dataObject.Price = $scope.totalPrice;
			dataObject.PublicEventID = $scope.PublicEventID;
		}

		if ( $scope.smodal.paymentMethod == '7' ) {
			dataObject.OrderID = $scope.BookingOrderID
		}

		if($scope.smodal.paymentMethod == '11' && $scope.paymentElavon.ElavonOrderID){
			dataObject.OrderID = $scope.paymentElavon.ElavonOrderID;
			dataObject.ЕlavonTransactionID = $scope.paymentElavon.ElavonTransactionID;
			$scope.formLoaded = true;
		}

		return dataObject;
	}


	$scope.formLoaded = true;
	var joinEventResponses = new Array('joinEventResponse1', 'joinEventResponse2', 'joinEventResponse3', 'joinEventResponse4', 'joinEventResponse5', 'joinEventResponse6', 'joinEventResponse7', 'joinEventResponseEmpty','joinEventResponseEmpty', 'joinEventResponse8', 'joinEventResponse9', 'joinEventResponse10');

	$scope.modalEventLink = function(){
		$scope.loading = true;

		if( $scope.modalPrice != null && $scope.modalPrice != undefined && Number($scope.modalPrice).toFixed(2) == 0.00){
			$scope.smodal.paymentMethod = '0';
			$scope.joinEvent();
		}else{
			if ($scope.smodal.paymentMethod == '7') {
				stripeConfirmPayment();
			}else{
				$scope.joinEvent();
			}
		}
	}

	$scope.joinEvent = function () {
		
		getEqipment($scope.modalVisit.ID, true);
		
	}

	function sendJoinEventRequest(){
		const dataObject = prepareDataToSned();

		if ($scope.formLoaded == true) {
			$scope.formLoaded = false;

			/// <returns>0:everything ok; 1:max people reached; 2:client already joined the event;3:the event doesnt exist;4:no membership;5 requires a deposit; 5 require profile; 7 schedule wasnt found; 8 Needs Waiver</returns>
			$http({
				method: 'POST',
				url: '/private/JoinEvent',
				data: dataObject
			}).success(function (data) {
				var responseI = data;
				$scope.joinEventResponse = joinEventResponses[responseI];
	
				if (responseI == 0) {
					if (dataObject.PaymentMethod == 8) {
						generateMyPos();
					}else if(dataObject.PaymentMethod == 9){
						generatePaymob();
					}else if(dataObject.PaymentMethod == 10){
						generateNetcash();
					}else if(dataObject.PaymentMethod == 12){
						generateCpay();
					}else if(dataObject.PaymentMethod == 13){
						generateXendit();
					}else{
						let translated = $translateThis($scope.joinEventResponse);
						Swal.fire({
							type: 'success',
							title: translated,
							onAfterClose: () => $scope.closePopup()
						});
						$scope.loading = false;
					}
					
				}else if(responseI == 11) {
					generateElavon();
				}else if(responseI == 1) {
					if($scope.modalVisit.WaitingList){
						$('#waitingModal').modal('show');
					}else{
						let translated = $translateThis($scope.joinEventResponse);
						Swal.fire({
							type: 'warning',
							title: translated,
							onAfterClose: () => $scope.closePopup()
						});
					}
					$scope.loading = false;
				}else if(responseI == 6) {
					let translated = $translateThis($scope.joinEventResponse);
					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: () => $scope.loading = false
					});
				}else if(responseI == 8){
					var translated = $translateThis('Waiver Required!Portal');
					var waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/Schedulev2/EmbedGroupSchedulev2';
					Swal.fire({
						type: 'warning',
						title: translated,
						showCancelButton: true,
					}).then(function(result) {
						if (result.value) {
							window.location.href = waiverHref;
						}else{
							$timeout(function() {
								$scope.formLoaded = true;
								$scope.loading = false;
							}, 1);
						}
					});
				}else if(responseI == 9) {
					let maxResPerDay = $scope.classSettings.MaxReservationsPerDay;
					let translated = $translateThis($scope.joinEventResponse, {value: maxResPerDay});

					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: () => $scope.loading = false
					});
				}else{
					let translated = $translateThis($scope.joinEventResponse);
					Swal.fire({
						type: 'warning',
						title: translated,
						onAfterClose: () => $scope.loading = false
					});
					$scope.formLoaded = true;
				}

				// $scope.loading = false;
			}).error(function (error) {
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			});
		}
	}

	function generatePaymob(){
		let dataObject = prepareDataToSned();
		dataObject.Language = lang;

		$http({
			method: 'POST',
			url: '/private/GeneratePaymobURL',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				let paymoblink = data;
                window.location.href = paymoblink;
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function generateElavon(){
		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateElavonToken',
			data: dataObject
		}).success(function (data) {

			openLightbox(data.ElavonToken)
			
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function openLightbox(token) {
		$scope.paymentElavon = {};
        var paymentFields = {
            ssl_txn_auth_token: token
        };
        var callback = {
            onError: function (error) {
                Swal.fire({
                    type: 'warning',
                    title: 'error',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });

                showResult("error", error,token);
            },
            onCancelled: function () {
                // showResult("cancelled", "",token);
                Swal.fire({
                    type: 'warning',
                    title: 'Cancelled',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });
            },
            onDeclined: function (response) {
                showResult("declined", JSON.stringify(response, null, '\t'), token);
                Swal.fire({
                    type: 'warning',
                    title: 'Declined',
                    onAfterClose: (function () {
                        $timeout(function() {
                            $scope.loading = false; 
                        });
                    })
                });
            },
            onApproval: function (response) {			
				$scope.paymentElavon.ElavonTransactionID = response.ssl_txn_id;
				$scope.paymentElavon.ElavonOrderID = response.ssl_invoice_number;
				sendJoinEventRequest();

                // showResult("approval", JSON.stringify(response, null, '\t'),token);
            }
        };
        PayWithConverge.open(paymentFields, callback);
        return false;
	}

	function showResult(status, msg, token) {
		console.log(status, msg)

		let url = '/membership/SaveElavonError/';
		let dataObject = {
			Token: token,
			Status: status,
			ExceptionText: msg,
			NameSpace: namespace
		}

		$http({
			method: 'POST',
			url: url,
			data: dataObject
		});
	}


	function generateNetcash(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateNetCashValues',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				post_to_url(data, 'post', 'https://paynow.netcash.co.za/site/paynow.aspx');
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function generateCpay(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateCPayValues',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				post_to_url(data, 'post', data.PaymentUrl);
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function generateXendit(){
		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateXenditValues',
			data: dataObject
		}).success(function (data) {
			if(data.IsSuccess == true){
				window.location.href = data.PaymentLinkUrl;
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: data.ErrorMessage,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function generateMyPos(){

		let dataObject = prepareDataToSned();
		dataObject.Language = lang;
		
		$http({
			method: 'POST',
			url: '/private/GenerateMyPosValues',
			data: dataObject
		}).success(function (data) {
			if(data != 'Error'){
				post_to_url(data, 'post');
			}else{
				let translated = $translateThis('ERROR');
				Swal.fire({
					type: 'warning',
					title: translated,
				});

		        $('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
		        $scope.formLoaded = true;
		        $scope.loading = false;
			}
			console.log(data);
		}).error(function (error) {
			let translated = $translateThis('ERROR');
			Swal.fire({
				type: 'warning',
				title: translated,
			});

			$('#eventScheduleModal .form-actions .button-reverse').addClass('disabled');
			$scope.formLoaded = true;
			$scope.loading = false;
		});
	}

	function post_to_url(params, method, url) {
		let path = $scope.classSettings.MyPosTestingMode ? 'https://www.mypos.com/vmp/checkout-test' : 'https://www.mypos.com/vmp/checkout';
		if(url){
            path = url;
        }
		method = method || "post";
		
		var form = document.createElement("form");
		form.setAttribute("method", method);
		form.setAttribute("action", path);
	
		for(var key in params) {
			if(params.hasOwnProperty(key)) {
				var hiddenField = document.createElement("input");
				hiddenField.setAttribute("type", "hidden");
				hiddenField.setAttribute("name", key);
				hiddenField.setAttribute("value", params[key]);
	
				form.appendChild(hiddenField);
			 }
		}
	
		document.body.appendChild(form);
		form.submit();
	}

	// CheckWaiver(string Email, int PublicEventID, int GymID, string Namespace)

	//setup before functions
	var typingEmail;
	var $inputEmail = $('#popupemail');

	//on keyup, start the countdown
	$inputEmail.on('keyup', function () {
	  clearTimeout(typingEmail);
	  if(!$inputEmail.is('.ng-invalid'))
	  	typingEmail = setTimeout(function() {checkWaiver()}, 2000);
	});

	//on keydown, clear the countdown 
	$inputEmail.on('keydown', function () {
	  clearTimeout(typingEmail);
	});


	function setStorage(){
		sessionStorage.setItem('urlParams', window.location.search);
	}

	function checkWaiver(){

		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			PublicEventID: $scope.PublicEventID,
			Email: $scope.client ? $scope.client.Email : $scope.smodal.email
		}
		
		$http({
			method: 'POST',
			url: '/private/CheckWaiver',
			data: dataObject
		}).success(function (data) {
			if(data.IsWaiverRequired){
			// if(data == 'Waiver Required!'){
				let translated = $translateThis('Waiver Required!Portal');
				if(data.WaiverTitle){
					translated = $translateThis('Waiver Required WaiverName!', { waiverName: data.WaiverTitle });
				}
				let waiverHref = window.location.origin + '/waiver/embedregistration?GymID=' + gymid + '&NameSpace=' + namespace + '&Redirect=/Schedulev2/EmbedGroupSchedulev2';
				Swal.fire({
					type: 'warning',
					title: translated,
					showCancelButton: true,
				}).then(function(result) {
					if (result.value) {

						setStorage();

						window.location.href = waiverHref;
					}else{
						$timeout(function() {
							$scope.formLoaded = true;
							$scope.loading = false;
						}, 1);
					}
				});
			}else{
				if($scope.client && $scope.clientGroupMembers.length <= 0)
					checkHasValidMembership();
			}
		}).error(function (error) {
			$scope.loading = false;
		});
	}

	$scope.closePopup = function () {
		$scope.resetForm();
		$scope.formLoaded = true;
	}

	$('#eventScheduleModal').on('hidden.bs.modal', function () {
		$scope.resetForm();
	})

	$scope.resetForm = function () {
		$('.event-form').find('input[type="text"], input[type="tel"], input[type="email"]').val('');
		$scope.waitingList = {};
		$scope.people = [];
		$scope.smodal = [];
		$scope.paymentElavon = {};
		$('#eventScheduleModal').modal('hide');
		$('#waitingModal').modal('hide');
		$('#optionClassBookingMembership').removeClass("hide");
		$('#selectPaymentMethod').addClass('disabled');
		$scope.clientGroupMemberSel = 0;
		$scope.modalPrice = null;
		$scope.$apply();
	}

	$scope.eventLink = function(event){
		$scope.peopleWaiting = 0;
		$scope.modalVisit = event;

		if($scope.client && $scope.client.BanBooking){
			let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
			let translatedConfirrm = $translateThis('Pay');
			// Swal.fire({
			// 	type: 'warning',
			// 	title: translated
			// });

			Swal.fire({
				type: 'warning',
				title: translated,
				showCloseButton: true,
				confirmButtonText: translatedConfirrm,
			}).then((result) => {
				/* Read more about isConfirmed, isDenied below */
				if (result.value) {
					$('#unBanModal').modal('show')
				}
			})

		}else{

			checkMaxPeopleArea(event.ID);
		}
	}

	function checkMaxPeopleArea(eventID){

		let dataObject = {
			ScheduleContentID: eventID,
			GymID: gymid,
			Namespace: namespace
		}

		$http({
			method: 'POST',
			url: '/private/CheckMaxPeopleAreaReached',
			data: dataObject
		}).success(function (data) {

			if( data == 0 ){
				if($scope.modalVisit.FullCapacity){
					if($scope.modalVisit.WaitingList && !$scope.modalVisit.Cancelled){
						$('#waitingModal').modal('show');
					}else{
						$scope.joinModal($scope.modalVisit.ID);
					}
					// $('#waiting-popup .popup, #waiting-popup').addClass('show');
				}else{

					if($scope.modalVisit.AgeRestriction && !$scope.client){
						let translated = $translateThis('You need to log in to your profile. The event has an age restriction.');
						let translatedConfirrm = $translateThis('LOGIN');
						Swal.fire({
							type: 'warning',
							title: translated,
							showCloseButton: true,
							confirmButtonText: translatedConfirrm,
						}).then((result) => {
							/* Read more about isConfirmed, isDenied below */
							if (result.value) {
								$('#loginModal').modal('show')
							}
						})
					}else{
						if($scope.allowBooking && $scope.modalVisit.BookOnline == true && $scope.modalVisit.AheadBooking && !$scope.modalVisit.Cancelled){
							// CheckForWaitingPeople(int ScheduleContentID, int GymID, string Namespace)
							checkForWaitingPeople();
						}else{
							$scope.joinModal($scope.modalVisit.ID);
						}
					}
				}
			}else{
				if($scope.modalVisit.WaitingList && !$scope.modalVisit.Cancelled){
					$('#waitingModal').modal('show');
				}else{
					let translated = $translateThis('Area capacity MaxPeople reached');
					Swal.fire({
						type: 'warning',
						title: translated
					});
				}
			}

		}).error(function (error) {
		});
	}

	function checkForWaitingPeople(eventID){
		let dataObject = {
			ScheduleContentID: $scope.modalVisit.ID,
			GymID: gymid,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/private/CheckForWaitingPeople',
			data: dataObject
		}).success(function (data) {
			$scope.peopleWaiting = data;
			if( data > 0 ){
				$('#waitingModal').modal('show');
				// $('#waiting-popup .popup, #waiting-popup').addClass('show');
			}else{
				$scope.joinModal($scope.modalVisit.ID);
			}

		}).error(function (error) {
		});
	}

	$scope.joinWaitingList = function(event){
		let dataObject = {
			Namespace: namespace,
			GymID: gymid,
			Id: event.ID,
			Email: $scope.client ? $scope.client.Email : $scope.waitingList.Email,
			Date: moment(event.NewDate).toISOString(),
			VisitName: event.VisitName,
			Language: lang,
			AdditionalGuests: $scope.people
		}

		if ( $scope.classSettings.ClassBookingRequireProfile != true ) {
			let tel;
			if($scope.inputPhone){
				tel = $scope.inputPhone.selectedDialCode.innerHTML + $scope.inputPhone.telInput.value;
				tel = tel.replace(/ /g,'');
			}

			dataObject.FirstName = $scope.client ? $scope.client.FirstName : $scope.scheduleFirstName;
			dataObject.LastName = $scope.client ? $scope.client.LastName : $scope.scheduleLastName;
			dataObject.Telephone = $scope.client ? $scope.client.Telephone : tel;
		}

		$http({
			method: 'POST',
			url: '/private/JoinWaitingList',
			data: dataObject
		}).success(function (data) {

			//0:everything ok; 1:no client found; 2:cannot add to waiting list; 3:error;4 already in the same waiting list; 7:no event found
			let response = data;

			if(response == 0){
				let translated = $translateThis('Thank you for joining the waitlist. You will receive an email if space becomes available.');
				Swal.fire({
					type: 'success',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 1){
				let translated = $translateThis('There is no customer with this email. Please contact reception.');
				Swal.fire({
					type: 'warning',
					title: translated
				});
			}else if(response == 2){
				let translated = $translateThis('Cannot add to waiting list');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 3){
				let translated = $translateThis('Error');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 4){
				let translated = $translateThis('You are already in the waitlist. We will send you an email if space becomes available');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 5){
				let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}else if(response == 7){
				let translated = $translateThis('no event found');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}
		}).error(function (error) {
		});
	}

	function getClientMembership(){

		let dataObject = {
			Namespace: namespace,
			ClientID: $scope.client.ClientID,
		}
		
		$http({
			method: 'POST',
			url: '/Membership/GetClientGroupMembers',
			data: dataObject
		}).success(function (data) {
			$scope.clientGroupMembers = data;
			if(data.length == 1 && data[0].ClientID == $scope.client.ClientID){
				$scope.clientGroupMembers = [];
				checkAgeRestriction($scope.client)
			}
			if(!data){
				checkAgeRestriction($scope.client)
			}

		}).error(function (error) {
			console.log(error);
		});
	}

	$scope.ageRestrictionStatus = true;
	function checkAgeRestriction(user, groupMember = false){
		if(user){
			let birthDate;
			if (groupMember) {
				const match = /\/Date\((-?\d+)\)\//.exec(user.Birthdate);
				birthDate = match ? new Date(parseInt(match[1])) : new Date(user.Birthdate);
			} else {
				birthDate = new Date(user.Birthdate);
			}
			const now = new Date();
			let age = now.getFullYear() - birthDate.getFullYear();
			const monthDiff = now.getMonth() - birthDate.getMonth();
			if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
				age--;
			}

			console.log(age);

			const minAge = $scope.modalVisit.MinAge;
			const maxAge = $scope.modalVisit.MaxAge;

			if (minAge === 0) {
				$scope.ageRestrictionStatus = age <= maxAge;
			} else if (maxAge === 0) {
				$scope.ageRestrictionStatus = age >= minAge;
			} else {
				$scope.ageRestrictionStatus = age >= minAge && age <= maxAge;
			}
		}else{
			$scope.ageRestrictionStatus = false;
		}
	}


	// Join Modal
	$scope.joinModal = function (visitId) {
		$scope.haveEquipment = true;
		$scope.visitProducts = [];
		$scope.clientGroupMemberSel = 0;
		$scope.clientGroupMembers = [];
		$scope.visitOriginalProducts = [];
		$scope.modalLoading = true;
		$scope.loading = true;
		var result = $.grep($scope.originalData, function (e) { return e.ID == visitId; });

		if ( result.length > 0 ) {
			$scope.PublicEventID = result[0].PublicEventID;
			$scope.modalVisit = result[0];
			$scope.noSlotsLeft = $scope.modalVisit.SlotsLeft > 1 ? false : true;

			var dayOfWeek = $filter('date')($scope.modalVisit.NewDate, 'EEEE');
			var compiledeHTML = $compile("<span translate-date-object-schedule><span class='day ng-binding'>" + dayOfWeek + "</span></span>")($scope);
			$(".dayofweekn").html(compiledeHTML);

			var now = new Date();

			if (now < $scope.modalVisit.HoursBeforeBooking) {
				// $('#shcedule-popup').addClass('show');
				$('#eventScheduleModal').modal('show');

				if($scope.allowBooking && $scope.modalVisit.BookOnline == true && $scope.modalVisit.AheadBooking && !$scope.modalVisit.Cancelled && !$scope.modalVisit.FullCapacity){
					getEventPrice();

					if($scope.client){
						getClientMembership();
					}

					setTimeout(function () {

						getEqipment(visitId);

						if($scope.client){
							checkWaiver();
						}else{
							$('#selectPaymentMethod').removeClass('disabled');
						}
						
					}, 10);
				}
			} else {
				let translated = $translateThis('Its too late to join this event.');
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: () => $scope.closePopup()
				});
			}
		}
	}

	// Check Valid Membership
	// HasValidMembership(int ClientID, int ScheduleID, int GymID, string Namespace)
	
	function checkHasValidMembership(member){
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ScheduleID: $scope.modalVisit.ID,
			ClientID: $scope.client.ClientID
		}

		if(member){
			dataObject.ClientID = member.ClientID
		}
		
		$http({
			method: 'GET',
			url: '/private/HasValidMembership?Namespace=' + namespace + '&GymID=' + gymid + '&ScheduleID=' + $scope.modalVisit.ID + '&ClientID=' + dataObject.ClientID,
			data: dataObject
		}).success(function (data) {
			// getEventPrice();

			if(data == 'true' || data == 'True' || data == true){
				$("#optionClassBookingMembership").removeAttr("disabled");
				$timeout(function() {
					$scope.smodal.paymentMethod = '1';
				}, 10);
				$('#selectPaymentMethod').addClass('disabled');
			}else{
				$timeout(function() {
					$scope.smodal.paymentMethod = '';
				});
				$('#selectPaymentMethod').removeClass('disabled');
				$("#optionClassBookingMembership").attr("disabled", "disabled");
			}

			$scope.formLoaded = true;
			$scope.loading = false;
		}).error(function () {
		});
	}

	$scope.$watch('clientGroupMemberSel', function (v) {
		if(v){
			var member = JSON.parse(v);
			checkHasValidMembership(member);
			checkAgeRestriction(member, true);
		}
	});


	function checkEqipment(){	
		let bookedPeople = [...$scope.people];

		if(bookedPeople.length > 0){
			bookedPeople.push({productId: $scope.smodal.productId})
			let group = bookedPeople.reduce((r, a) => {
				r[a.productId] = [...r[a.productId] || [], a];
				return r;
			}, {});

			for (var key in group) {
				if(key > 0){
					let item = $scope.visitOriginalProducts.find((item) => item.ProductID == key);
					if( item.ItemsLeft >= group[key].length){
						$scope.haveEquipment = true;
					}else{
						$scope.haveEquipment = false;
						break;
					}
				}else{
					$scope.haveEquipment = true;
				}
			}
		}else{
			if($scope.visitOriginalProducts.length && $scope.smodal.productId != '-1'){	
				let item = $scope.visitOriginalProducts.find((item) => item.ProductID == $scope.smodal.productId);
				if(item.ItemsLeft>0){
					$scope.haveEquipment = true;
				}else{
					$scope.haveEquipment = false;
				}
			}
		}


		if($scope.haveEquipment){
			sendJoinEventRequest();
		}
	}

	function getEqipment(visitId, final = false){
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ID: visitId
		}

		$http({
			method: 'GET',
			url: '/api/public/GetEqipment?nameSpace=' + namespace + '&gymId=' + gymid + '&ID=' + visitId,
			data: dataObject
		}).success(function (data) {
			if($scope.visitProducts.length == 0){
				$scope.visitProducts = data;
			}
			$scope.visitOriginalProducts = [...data];
			$scope.modalLoading = false;
			if(final){
				checkEqipment();
			}else{
				$scope.loading = false;
			}
			
		}).error(function () {

		});
	}

	$scope.getAttendingClients = function(item){

		if(!item.AttendingClients){
			// $scope.modalLoading = true;

			var dataObject = {
				Namespace: namespace,
				GymID: gymid,
				ScheduleID: item.ID,
				AreaID: item.AreaID
			}

			$http({
				method: 'GET',
				url: '/private/GetAttendingClients?Namespace=' + namespace + '&GymID=' + gymid + '&ScheduleID=' + item.ID + '&AreaID=' + item.AreaID,
				data: dataObject
			}).success(function (data) {
				item.attedingCleints = data;

				$scope.clientsData = item.attedingCleints;
				$('#attendantsModal').modal('show');

				// $('#clients-popup, #clients-popup .popup').addClass('show');
				// $scope.modalLoading = false;

			}).error(function () {
				// console.log('error');
			});
		}else{
			$('#attendantsModal').modal('show');
			// $('#clients-popup, #clients-popup .popup').addClass('show');
			$scope.clientsData = item.AttendingClients
		}
	}

	function calcPopupHeight(){
        let windowHeight = $(window).height();
        let popupHeight = $('.login-popup .popup .section-authorize').height();

        if(popupHeight + 40 >= windowHeight){
            $('.login-popup .popup').addClass('overflowScroll');
        }else{
            $('.login-popup .popup').removeClass('overflowScroll');
        }
    }

	function calculateEventPrice(){
		if ( $scope.people.length > 0 ) {
			$scope.additionPrice = $scope.people.length*parseFloat($scope.modalPrice);
			$scope.totalPrice = (parseFloat($scope.additionPrice) + parseFloat($scope.modalPrice)).toFixed(4);
		}else{
			$scope.totalPrice = $scope.modalPrice;
		}

		$scope.noSlotsLeft = $scope.modalVisit.SlotsLeft > $scope.people.length + 1 ? false : true;
	}

	$scope.people = [];
	$scope.noSlotsLeft = false;

	$scope.addPerson = function(){
		let person = {};
		$scope.people.push(person);
		calculateEventPrice();
	}

	$scope.deletePerson = function(index){
		let item = $scope.people[index];

		if (item.productId > -1) {
			let result = $.grep($scope.visitProducts, function (e) { return e.ProductID == item.productId });
			result[0].ItemsLeft = ++result[0].ItemsLeft;
		}
		$scope.people.splice(index,1);
		calculateEventPrice();
	}

	$('.popup-wrapper .close, .popup-wrapper .popup-overlay').on('click', function (e) {
		e.preventDefault();
		$('.popup-wrapper, #shcedule-popup .popup, #shcedule-popup .error-msg, #shcedule-popup .success-msg').removeClass('show');
		$scope.resetForm();
	})

	// Datepickers

	schedule_from.datepicker({
		changeMonth: true,
		changeYear: true,
		numberOfMonths: 2,
		minDate: 0,
		onSelect: function (dateText, inst) {
			var date = $(this).val();
			schedule_to.datepicker("option", "minDate", date);

			if (gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			$scope.scheduleStartDate = date;
		}
	});

	schedule_to.datepicker({
		changeMonth: true,
		changeYear: true,
		numberOfMonths: 2,
		minDate: 1,
		onSelect: function (dateText, inst) {
			var date = $(this).val();
			schedule_from.datepicker("option", "maxDate", date);

			if (gym[0].Culture != 'en-US') {
				var res = date.split("/");
				var date = res[1] + '/' + res[0] + '/' + res[2];
			}

			var tomorrow = new Date(date);
			tomorrow.setDate(tomorrow.getDate() + 1);

			$scope.scheduleEndDate = tomorrow;
		}
	});

	if($scope.classSettings.ShowScheduleDaysAhead > 0 ){
		let days = $scope.classSettings.ShowScheduleDaysAhead - 1;
		let today = new Date();
		today.setDate(today.getDate() + days);
		maxDate = new Date(today);

		schedule_from.datepicker("option", "maxDate", maxDate);
		schedule_to.datepicker("option", "maxDate", maxDate);

	}else if(days != null) {
		days -= 1;
		let today = new Date();
		today.setDate(today.getDate() + days);
		maxDate = new Date(today);

		schedule_from.datepicker("option", "maxDate", maxDate);
		schedule_to.datepicker("option", "maxDate", maxDate);
	}

	$('.ui-datepicker').addClass('notranslate');

	if (gym[0].Culture == 'en-US') {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "mm/dd/yy" );
	} else {
		$('#schedule_to, #schedule_from').datepicker( "option", "dateFormat", "dd/mm/yy" );
	}


	function getDate(element) {
		var date;
		try {
			date = $.datepicker.parseDate(dateFormat, element.value);
		} catch (error) {
			date = null;
		}
		return date;
	}

	$('.schedule-wrapper .filter-section .date-col i').on('click', function (e) {
		$(this).parent().find('input').datepicker('show');
	})

	// 
	// Unban Code Starts Here
	// 

	$scope.unBanMe = function(){
		$scope.loading = true;
		// ScheduleV2/UnBanClientPaymentValues(int ClientID, string PaymentType, string Namespace, int GymID, string Language)
		var dataObject = {
			Namespace: namespace,
			GymID: gymid,
			ClientID: $scope.client.ClientID,
			PaymentType: $scope.unbanModel.paymentMethod,
			Language: lang
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/UnBanClientPaymentValues',
			data: dataObject
		}).success(function (data) {

			if(data.Success){
				if(data.StripeValues){
					stripeConfirmCardUnban(data.StripeValues, data.OrderID)
				}else if(data.MyPosValues){
					post_to_url(data.MyPosValues, 'post');
				}
			}else{
				let translated = $translateThis(data.ResponseMsg);
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: function (a){
						$timeout(() => $scope.loading = false)
					}
				});
			}
			
		}).error(function () {
			// console.log('error');
		});
	}

	function stripeConfirmCardUnban(data, orderId){

		let name = $scope.client.FirstName + ' ' + $scope.client.LastName;

		$scope.stripeUnban.confirmCardPayment(data.ClientSecret, {
			payment_method: {
				card: $scope.cardUnban,
				  billing_details: {
					name: name
				  }
			}
		}).then(function(result) {
			if (result.error) {
				// Show error to your customer (e.g., insufficient funds)
				let translated = $translateThis(result.error.message);
				Swal.fire({
					type: 'warning',
					title: translated,
					onAfterClose: function (a){
						$scope.loading = false;
					}
				});
			} else {
				  // The payment has been processed!
				  if (result.paymentIntent.status === 'succeeded') {
					// $scope.joinEvent();
					$scope.cardUnban.clear();
					unBanClientComplete(result.paymentIntent.id, orderId);

					// Show a success message to your customer
					// There's a risk of the customer closing the window before callback
					// execution. Set up a webhook or plugin to listen for the
					// payment_intent.succeeded event that handles any business critical
					// post-payment actions.
				  }else{
					$scope.loading = false;
				  }
			}
		});
	}

	// ScheduleV2/UnBanClientComplete(int ClientID, string PaymentType, string PaymentIntentID, int OrderID, int GymID, string Namespace)

	function unBanClientComplete(intent, orderId){
		var dataObject = {
			GymID: gymid,
			Namespace: namespace,
			ClientID: $scope.client.ClientID,
			PaymentType: $scope.unbanModel.paymentMethod,
			PaymentIntentID: intent,
			OrderID: orderId
		}
		$http({
			method: 'POST',
			url: '/ScheduleV2/UnBanClientComplete',
			data: dataObject
		}).success(function (data) {
			let translated = $translateThis(data.ResponseMsg);
			let status = data.Success ? 'success' : 'warning';
			Swal.fire({
				type: status,
				title: translated,
				onAfterClose: function (a){
					$timeout(() => {
						$scope.loading = false;
						$scope.client.BanBooking = false;
					})
					
					$('#unBanModal').modal('hide');
				}
			});
		}).error(function () {
			let translated = $translateThis('Error');
			Swal.fire({
				type: 'warning',
				title: translated,
				onAfterClose: function (a){
					$timeout(() => $scope.loading = false)
				}
			});
		});
	}



	$scope.unbanpaymentChange = function(){
		if ($scope.unbanModel.paymentMethod == '7') {

			// Stripe
			$scope.stripeUnban = Stripe($scope.classSettings.StripePublishKey);
			// Create a Stripe client.
			// var stripe = Stripe($scope.classSettings.StripePublishKey);
			// Create an instance of Elements.
			var elements = $scope.stripeUnban.elements();
			// Custom styling can be passed to options when creating an Element.
			// (Note that this demo uses a wider set of styles than the guide below.)
			var style = {
				base: {
				color: '#32325d',
				lineHeight: '18px',
				fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '16px',
				'::placeholder': {
					color: '#aab7c4'
				}
				},
				invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
				}
			};

			// Create an instance of the card Element.
			// $scope.card = elements.create('card', {style: style});
			$scope.cardUnban = elements.create('card', {style: style, hidePostalCode: $scope.classSettings.HidePostalCode });

			// Add an instance of the card Element into the `card-element` <div>.
			$scope.cardUnban.mount('#card-element-unban');

			// Handle real-time validation errors from the card Element.
			$scope.cardUnban.addEventListener('change', function(event) {
				var displayError = document.getElementById('card-errors-unban');
				if (event.error) {
					displayError.textContent = event.error.message;
				} else {
					displayError.textContent = '';
				}
			});
		}
	}

	// private/GetUnBanVisitPrice(int GymID, string Namespace)
	if($scope.client){
		getUnBanVisitPrice();
	}

	function getUnBanVisitPrice(){
		var dataObject = {
			GymID: gymid,
			Namespace: namespace
		}
		$http({
			method: 'POST',
			url: '/private/GetUnBanVisitPrice',
			data: dataObject
		}).success(function (data) {
			$scope.unBanPrice = data;

			if($scope.client.BanBooking){

				let translated = $translateThis('Your access to the booking system has been suspended due to non-compliance with the rules of the sports center. Please contact reception.');
				let translatedConfirrm = $translateThis('Pay');

				if($scope.client.BanBooking && $scope.unBanPrice > 0){
					Swal.fire({
						type: 'warning',
						title: translated,
						showCloseButton: true,
						confirmButtonText: translatedConfirrm,
					}).then((result) => {
						/* Read more about isConfirmed, isDenied below */
						if (result.value) {
							$('#unBanModal').modal('show')
						}
					})
				}else{
					Swal.fire({
						type: 'warning',
						title: translated
					});
				}
			}
		}).error(function () {
			// console.log('error');
		});
	}

	$scope.unbanModel = {paymentMethod: null};
	$('#unBanModal').on('shown.bs.modal', function () {
		if($('#selectPaymentMethodUnban option.ng-scope').length == 1){
			$timeout(() => $scope.unbanModel.paymentMethod = $('#selectPaymentMethodUnban option.ng-scope').val())
			$scope.unbanpaymentChange();
		}
	})

	// 
	// Unban Code Ends Here
	// 

	// function manageDays(){
	// 	$('.schedule-list .list-item').removeClass('show');
	// 	$('.schedule-list').addClass('hide');
	// 	for (var i = 0; i < days; i++) {
	// 		$('.schedule-list .list-item').eq(i).addClass('show');
	// 	}
	// }

	function scroll(){

		var windowHeight = $(window).height();
		var contentHeight = $('.schedule-wrapper').height();

		if ( contentHeight > windowHeight ) {
			var timeScrollDown = contentHeight;
			var timeScrollUp = contentHeight;

			if ( (contentHeight - windowHeight) > 2000 ) {
				timeScrollDown = parseInt(timeScrollDown*25);
				timeScrollUp = parseInt(timeScrollUp*20);
			}else if ( (contentHeight - windowHeight) > 500 ){
				timeScrollDown = parseInt(timeScrollDown*25);
				timeScrollUp = parseInt(timeScrollUp*10);
			}else if( (contentHeight - windowHeight) > 250 ){
				timeScrollDown = parseInt(timeScrollDown*22);
				timeScrollUp = parseInt(timeScrollUp*7);
			}else if( (contentHeight - windowHeight) > 100 ){
				timeScrollDown = parseInt(timeScrollDown*21);
				timeScrollUp = parseInt(timeScrollUp*5);
			}else{
				timeScrollDown = parseInt(timeScrollDown*20);
				timeScrollUp = parseInt(timeScrollUp*3);
			}
			
			if ( $(window).scrollTop() == 0 ){
				$('html, body').clearQueue();
  				$('html, body').stop();
  				setTimeout(function() {
					$("html, body").animate({ scrollTop: $(document).height() }, timeScrollDown, 'linear');
  				}, 2000);
			}else if ( $(window).scrollTop() + $(window).height() == $(document).height() ){
				$('html, body').clearQueue();
  				$('html, body').stop();
  				setTimeout(function() {
					$('html, body').animate({scrollTop:0}, timeScrollUp, 'linear');
  				}, 2000);
			}
		}
	}
	
	$(window)
	.on('load', function () {
		setTimeout(function () {

			if (calendarView) {
				$('.switch-field a.calendar').trigger('click');
			}else{
				$('#calendar').hide();
				$('body').addClass('loaded-body');
			}

			if (pageScroll) {
				scroll();
			}
			
		}, 1000);

		if( sessionStorage.getItem('urlParams') ){
			sessionStorage.clear();
		}

		resizeAndDatepicker();

		let phoneLang = getLanguage($scope.gym[0].Culture);
		var inputInitPhone = document.querySelector("#popuptelephone");
		
        if(inputInitPhone){

			if($scope.gym[0].Culture.includes('GB')){
				$('#popuptelephone')
				.on('keydown', function (e) {
					if(e.keyCode == 32){
						return false;
					}
				})
				.on('keyup', function (e) {
					if(e.target.value.length == 4){
						e.target.value = e.target.value += ' ';
					}
				});
			}

            $scope.inputPhone = window.intlTelInput(inputInitPhone, {
                autoHideDialCode: false,
                preferredCountries: [phoneLang],
                separateDialCode: true
            });

			inputInitPhone.addEventListener("countrychange", function() {
                let countryinfo = $scope.inputPhone.getSelectedCountryData()
                if(countryinfo.dialCode == '44'){
                    inputInitPhone.value = inputInitPhone.value.split(' ').join('');
                    if(inputInitPhone.value.length > 4){
                        inputInitPhone.value = inputInitPhone.value.substring(0, 4) + " " + inputInitPhone.value.substring(4, 10);
                    }
                    $scope.phoneFormat = /^[0-9\s]{5,11}$/;
                    $('#popuptelephone')
                    .on('keydown', function (e) {
                        if(e.keyCode == 32){
                            return false;
                        }
                    })
                    .on('keyup', function (e) {
                        if(e.target.value.length == 4){
                            e.target.value = e.target.value += ' ';
                        }
                    });
                }else{
                    inputInitPhone.value = inputInitPhone.value.split(' ').join('');
                    $scope.phoneFormat = /^[0-9]{5,15}$/;
                    $scope.waiverForm.Telephone.$validate()
                    $('#popuptelephone')
                    .on('keydown', function (e) {
                        if(e.keyCode == 32){
                            return false;
                        }
                    })
                    .on('keyup', function (e) {
                        if(e.target.value.length == 4){
                            // e.target.value = e.target.value += ' ';
                        }
                    });
                }
            });
        }
	})
	.on('resize', function(){
		resizeAndDatepicker();

		calcPopupHeight();
	})
	.on('scroll', function(){
		if (pageScroll) {
			scroll();
		}
	})


	// Get Language from backend settings
	function getLanguage(culture){
		let lang = culture.split('-');
		lang = lang[1].toLowerCase();
		return lang;
	}

	$scope.dateFeaturedFormat = 'dd/MM/yyyy';

	if (gym) {
		if (gym[0].PortalColor != null && gym[0].PortalColor != 'default') {
			$('.schedule-wrapper').addClass('theme-' + gym[0].PortalColor);
		}

		if ( gym[0].Culture == 'en-US' ) {
			$scope.dateFeaturedFormat = 'MM/dd/yyyy';
		}
	}

	//  Check Window Size and change datepicker options
	function resizeAndDatepicker(){
		var windowWidth = $(window).width();

		if ( windowWidth <= 768 ) {
			schedule_from.datepicker("option", "numberOfMonths", 1);
			schedule_to.datepicker("option", "numberOfMonths", 1);
		}else{
			schedule_from.datepicker("option", "numberOfMonths", 2);
			schedule_to.datepicker("option", "numberOfMonths", 2);
		}
	}

	$('#loginModal').on('shown.bs.modal', function () {
		$.fn.modal.Constructor.prototype._enforceFocus = function () { };
	});

}]);